import { generateParams } from '@/utils/helpers';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

import instance from '../instance';

const errorMapper = new ErrorMapper();
const resource = '/attachments';

export default {
  collectionsAttachments: async function ({ params = [], token }) {
    try {
      const paramsString = generateParams(params);

      return await instance.get(`${resource}/collectionsAttachments${paramsString}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  getShared: async function (params = []) {
    try {
      const paramsString = generateParams(params);
      return await instance.get(`${resource}/list/shared${paramsString}`);
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  getAttachments: async function ({ token, id }) {
    try {
      return await instance.get(`${resource}/?collection=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  getPublic: async function (params = []) {
    try {
      const paramsString = generateParams(params);
      return await instance.get(`${resource}/list/public${paramsString}`);
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  updateAttachment: async function ({ token, id, payload }) {
    try {
      return await instance.patch(`${resource}/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  deleteOne: async function ({ token, id }) {
    try {
      return await instance.delete(`${resource}/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
};
